<template>
  <div :class="{ 'pix-generic-form__container': sectionLabel, 'center-spinner': loading }">
    <i v-if="loading" class="mdi mdi-spin mdi-loading mdi-spinner" />

    <template v-else>
      <div v-if="sectionLabel" class="pix-generic-form__container__header__title">
        <span>{{ sectionLabel }}</span>
      </div>
      <div class="pix-generic-table__content">
        <!-- <div class="table-responsive table-editable"> -->
        <div>
          <template v-if="headerButtons && headerButtons.length">
            <div v-for="button in headerButtons" :key="button.RowId" class="table__actions" :class="button.Format">
              <span>
                <pix-button @click="fnCallBack($event, button, null)" :disabled="readonly || (allTheColumnsAreConfidential && (shouldDisableActions || shouldBlurConfidentialFields))" :label="button.Label" />
              </span>
            </div>
          </template>

          <!-- <table class="table table-sm table-condensed table-hover table-bordered small m-0"> -->
          <table class="pix-generic-table">
            <thead>
              <tr>
                <th v-if="showTotals && !readonly" class="border-0"></th>
                <th v-if="multiselect && showMultiColumn && !readonly" class="text-center subtable-header-style">
                  <div v-show="lstOfDatRows && lstOfDatRows.length > 0" class="wPointer">
                    <span class="mdi mdi-checkbox-blank-outline" v-if="!isAllRowSelected" @click="fnToggleAllSel()"></span>
                    <span class="mdi mdi-checkbox-marked-outline" v-if="isAllRowSelected" @click="fnToggleAllSel()"></span>
                    <sup class="">{{ $n(selectedRows.length) }}</sup>
                  </div>
                </th>
                <th v-if="hasSubtable" class="text-center subtable-header-style"></th>
                <th
                  v-for="column in columnsToDisplay"
                  :class="{
                    'bg-primary text-light background-color': column.sort !== 'NOS',
                    'subtable-header-style': column.sort === 'NOS',
                  }"
                  :key="column.RowId"
                  :data-qa-id="`${column.DataQaId}-label`"
                >
                  <template v-if="fnEvalCondition(column.Conditions) && fnIsVisible(column) && column.gtShown">
                    <div
                      @click.left.prevent="fnSortBy(column)"
                      @click.right.prevent="fnShowColModal()"
                      :class="{
                        wPointer: column.CanSort === true,
                      }"
                    >
                      <div class="">
                        <span class="mdi mdi-blank" v-if="shouldShowUnorderedIcon(column)"></span>
                        <span class="up-down-icon" v-if="shouldShowUnorderedIcon(column)">
                          <span class="mdi mdi-menu-up"></span>
                          <span class="mdi mdi-menu-down"></span>
                        </span>
                        <span class="mdi mdi-menu-down" v-if="column.sort === 'DESC' && column.CanSort === true"></span>
                        <span class="mdi mdi-menu-up" v-if="column.sort === 'ASC' && column.CanSort === true"></span>
                        <span v-if="!column.IconHeader">{{ column.Label }}</span>
                        <span v-if="column.IconHeader" :class="column.IconHeader"></span>
                        <sup v-if="badgeColSortOrder(column) !== -1">{{ badgeColSortOrder(column) }}</sup>
                      </div>
                    </div>
                  </template>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="{
                  'table-secondary': isRowSelected(entry),
                  'bg-info-row': applyInfoBackground,
                }"
                v-for="(entry, index) in lstOfDatRows"
                :key="`${index}-${entry.RowId}`"
                :id="`gtable-${tableId}-${index}`"
                :data-uid="`gtable-${tableId}-${index}`"
                @mouseover="fnMouseOver(index)"
                @mouseleave="fnMouseLeave(index)"
                @click="handleRowClick(entry)"
              >
                <td :id="`gtable-${tableId}-${index}-show-totals`" :data-uid="`gtable-${tableId}-${index}-show-totals`" v-if="showTotals && !readonly" class="border-0"></td>
                <td
                  v-if="multiselect && showMultiColumn && !readonly"
                  class="text-center align-middle"
                  :id="`gtable-${tableId}-${index}-multiselect`"
                  :data-uid="`gtable-${tableId}-${index}-multiselect`"
                  @click="fnRowClick(entry, index)"
                  @dblclick="fnDoubleRowClick(entry, index)"
                >
                  <div class="wPointer">
                    <span class="mdi mdi-checkbox-blank-outline" v-show="!isRowSelected(entry)"></span>
                    <span class="mdi mdi-checkbox-marked-outline" v-show="isRowSelected(entry)"></span>
                  </div>
                </td>
                <td :id="`gtable-${tableId}-${index}-has-subtable`" :data-uid="`gtable-${tableId}-${index}-has-subtable`" v-if="hasSubtable" class="text-center align-middle" @click="entry.collapsed = !entry.collapsed">
                  <div class="wPointer">
                    <span :class="`mdi mdi-chevron-${entry.collapsed ? 'right' : 'down'}`" />
                  </div>
                </td>
                <td :id="`gtable-${tableId}-${index}-${indexCol}`" :data-uid="`gtable-${tableId}-${index}-${indexCol}`" v-for="(col, indexCol) in columnsToDisplay" :key="col.RowId" class="align-middle">
                  <template v-if="fnEvalCondition(col.Conditions) && fnIsVisible(col) && col.gtShown">
                    <template v-if="shouldBlur(col)">
                      <pix-blurred-field />
                    </template>

                    <template v-else>
                      <template v-if="col.IsEditable && !readonly">
                        <pix-select
                          :id="`gtable-${tableId}-${index}-${indexCol}-select`"
                          :data-qa-id="`${col.DataQaId}-row-${index}`"
                          v-if="col.FieldControlType === 'select'"
                          v-model="entry[col.InternalField]"
                          :options="getParamList(col, entry)"
                          label="ValueDesc"
                          track-by="ValueCode"
                          emit-value
                          :readonly="shouldBeReadOnly(col)"
                        />

                        <pix-checkbox
                          :id="`gtable-${tableId}-${index}-${indexCol}-checkbox`"
                          :data-qa-id="`${col.DataQaId}-row-${index}`"
                          v-model="entry[col.InternalField]"
                          v-if="col.FieldControlType === 'checkbox'"
                          :readonly="shouldBeReadOnly(col)"
                        />

                        <pix-input
                          :id="`gtable-${tableId}-${index}-${indexCol}-input`"
                          :data-qa-id="`${col.DataQaId}-row-${index}`"
                          v-model="entry[col.InternalField]"
                          @input="handleTableInput(entry)"
                          v-if="col.FieldControlType === 'input'"
                          :type="col.FieldDataType"
                          :min="-2147483648"
                          :max="2147483647"
                          :readonly="shouldBeReadOnly(col)"
                          :input-format="col.Format"
                        />

                        <pix-datepicker
                          :id="`gtable-${tableId}-${index}-${indexCol}-datepicker`"
                          :data-qa-id="`${col.DataQaId}-row-${index}`"
                          v-if="col.FieldControlType === 'datepicker' && userDateFormat"
                          v-model="entry[col.InternalField]"
                          :format="userDateFormat"
                          :fieldName="`gtable-${tableId}-${index}-${indexCol}-datepicker`"
                          :readonly="shouldBeReadOnly(col)"
                        />
                      </template>

                      <template v-else>
                        <div v-if="col.ParamId === null && col.CellType === null">
                          {{ fnGetDataValue(entry, col) }}
                        </div>
                        <div v-if="col.ParamId !== null && (!col.conditionalValues || col.conditionalValues.length === 0)">
                          {{ formatValueCodParam(fnGetDataValue(entry, col), col.ParamListValues) }}
                        </div>
                        <cell-dt-string-type-component v-if="col.CellType === 'StringType'" :value="fnGetDataValue(entry, col)" :index="index" :readTransform="col.ReadTransform" :conditionsDict="col.conditionalValues" />

                        <div v-if="col.CellType === 'DateType'">{{ getDateWithoutTimeZoneInUserFormat(fnGetDataValue(entry, col)) }}</div>

                        <cell-dt-typeahead-type-component v-if="col.CellType === 'AutocompleteType'" :value="fnGetDataValue(entry, col)" :config="col" />

                        <cell-dt-number-type-component
                          v-if="col.CellType === 'NumberType'"
                          :value="fnGetDataValue(entry, col)"
                          :outcomes="col.Values"
                          :format="col.Format"
                          :readTransform="col.ReadTransform"
                          :conditionsDict="col.conditionalValues"
                          :index="index"
                          :currency="getCurrencyParam(index)"
                          :area="getAreaParam(index)"
                          :frequency="getFreqParam(index)"
                        />

                        <cell-dt-boolean-type-component v-if="col.CellType === 'BooleanType'" :value="fnGetDataValue(entry, col)" :outcomes="col.Values" />

                        <cell-dt-link-type-component
                          v-if="col.CellType === 'LinkType'"
                          class="cell-linktype"
                          :class="`cell-linktype-${col.InternalField}`"
                          :col="col"
                          :value="fnGetDataValue(entry, col)"
                          :index="index"
                          :conditionsDict="col.conditionalValues"
                          :readTransform="col.ReadTransform"
                          :format="col.Format"
                          :currency="getCurrencyParam(index)"
                          :area="getAreaParam(index)"
                          :frequency="getFreqParam(index)"
                          :precedent="getPrecedentNum(index)"
                          :disabled="allTheColumnsAreConfidential && (shouldDisableActions || shouldBlurConfidentialFields)"
                          @btn-click="fnCallBack($event, col, entry)"
                        />

                        <router-cell v-if="col.CellType === 'RouterType'" :value="fnGetDataValue(entry, col)" :config-column="col" :data-row="entry" />

                        <pre v-if="col.CellType === 'PreType'" v-text="fnGetDataValue(entry, col)" />

                        <cell-dt-toggle-type-component v-if="col.CellType === 'ToggleType'" :value="fnGetDataValue(entry, col)" :index="index" :toggleKey="keyDate" color="var(--jll-red-400)" @btn-click="fnCallBack($event, col, entry)" />
                      </template>
                    </template>
                  </template>
                </td>
              </tr>

              <!-- Totals row -->
              <tr v-if="hasTotalsRow && !!lstOfDatRows && !!lstOfDatRows.length" class="pix-generic-table__total-row">
                  <td v-for="(column, columnIndex) in columnsToDisplay" :key="columnIndex" class="pix-generic-table__total-cell">
                      <pix-input v-model="totalsRowData[column.InternalField]" :type="column.FieldDataType" readonly :input-format="column.Format" />
                  </td>
              </tr>

              <tr v-if="hasSubtable && !entry.collapsed">
                <td :id="`gtable-${tableId}-${index}-subtable`" :data-uid="`gtable-${tableId}-${index}-subtable`" :colspan="2 * columnsToDisplay.length" class="subtableFontSize subtableBackground">
                  <keep-alive>
                    <component :is="subtableComponent.component" :id="entry[keyField]" />
                  </keep-alive>
                </td>
              </tr>
              <slot name="pagination" />
            </tbody>
          </table>
        </div>
        <div v-if="!lstOfDatRows || lstOfDatRows.length === 0">
          <div class="alert alert-warning text-center" role="alert">No Data</div>
        </div>
      </div>
      <!-- Modal de columnas -->
      <div class="modal fade" :id="idcolumnListModal" data-backdrop="static" tabindex="-1" role="dialog" aria-hidden="true" ref="modalColumns">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ $t('components.genericTable.columnList.modalTitle') }}
              </h5>
              <button type="button" class="close" @click.prevent="closeModal()" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-0">
              <div class="table-responsive text-nowrap">
                <table class="table table-sm table-condensed table-hover table-bordered small m-0">
                  <thead>
                    <tr>
                      <th class="text-light">
                        {{ $t('components.genericTable.columnList.index') }}
                      </th>
                      <th class="text-light" width="100%">
                        {{ $t('components.genericTable.columnList.column') }}
                      </th>
                      <th class="text-center">
                        {{ $t('components.genericTable.columnList.isVisible') }}
                      </th>
                    </tr>
                  </thead>
                  <draggable v-model="modalColumns" tag="tbody" handle=".handle">
                    <tr v-for="(column, index) in modalColumns" :key="column.gtOrder">
                      <template v-if="fnEvalCondition(column.Conditions) && fnIsVisible(column)">
                        <td
                          :class="{
                            'text-muted': column.gtShown === false,
                          }"
                        >
                          <div class="">
                            <span class="mdi mdi-menu grabbable handle"></span>
                            {{ index }}
                          </div>
                        </td>
                        <td
                          :class="{
                            'text-muted': column.gtShown === false,
                          }"
                          width="100%"
                        >
                          {{ column.Label }}
                        </td>
                        <td
                          :class="{
                            'text-center wPointer': column.gtShown === true,
                            'text-center table-secondary wPointer': column.gtShown === false,
                          }"
                        >
                          <div @click="column.gtShown = !column.gtShown">
                            <span class="mdi mdi-checkbox-blank-outline" v-if="!column.gtShown"></span>
                            <span class="mdi mdi-checkbox-marked-outline" v-if="column.gtShown"></span>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-warning" @click.prevent="fnResetTableConf()">
                {{ $t('common.lblReset') }}
              </button>
              <button type="button" class="btn btn-outline-primary" @click.prevent="fnSaveTableConf()">
                {{ $t('common.lblSave') }}
              </button>
              <button type="button" class="btn btn-primary" data-dismiss="modal" @click.prevent="closeModal()">
                {{ $t('common.lblClose') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Totals -->
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import draggable from 'vuedraggable';
import CellDtNumberTypeComponent from './cells/cellDtNumberType.vue';
import cellDtBooleanTypeComponent from './cells/cellDtBooleanType.vue';
import CellDtLinkTypeComponent from './cells/cellDtLinkType.vue';
import RouterCell from './cells/routerCell.vue';
import CellDtStringTypeComponent from './cells/cellDtStringType.vue';
import CellDtTypeaheadTypeComponent from './cells/cellDtTypeaheadType.vue';
import CellDtToggleTypeComponent from './cells/cellDtToggleType.vue';
import pixRegexUtils from '@/services/regularExpressions/pixRegex.utils.js';
import pixDatepicker from 'pix-datepicker';
import pixSelect from 'pix-select';
import pixInput from 'pix-input';
import pixCheckbox from 'pix-checkbox';
import pixUtils from '@/services/common/pix.utils';
import computedOperationUtils from '@/services/common/computedOperation.utils';
import Console from '@/shared/console';
import { mapActions } from 'vuex';
import pixButton from 'pix-button';
import momentMixin from '@/mixins/moment.mixin';
import blurrableMixin from '@/mixins/blurrable.mixin';
import regexConst from '@/consts/regex.const.js';
import pixEvaluateUtils from '@/services/common/pixEvaluate.utils.js';
import jllLocalstorageManager from 'jll-localstorage-manager';
/* eslint-disable no-plusplus */

export default {
  name: 'pix-generic-table',

  mixins: [momentMixin, blurrableMixin],

  components: {
    draggable,
    CellDtNumberTypeComponent,
    cellDtBooleanTypeComponent,
    CellDtTypeaheadTypeComponent,
    CellDtLinkTypeComponent,
    RouterCell,
    CellDtStringTypeComponent,
    CellDtToggleTypeComponent,
    pixDatepicker,
    pixSelect,
    pixInput,
    pixCheckbox,
    pixButton,
  },

  props: {
    dataRows: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    addButtonText: { type: String, default: '' },
    multiselect: { type: Boolean, default: false },
    uniqueTableName: { type: String, default: null },
    showModalColumnConfig: { type: Boolean, default: true },
    allowColumnConfig: { type: Boolean, default: true },
    showMultiColumn: { type: Boolean, default: true },
    outsideRowSelected: null,
    outsideSort: { type: Boolean, default: false },
    nSelectedRows: {
      type: Array,
      default() {
        return [];
      },
    },
    keyField: { type: String, default: null }, // contains the field name that will be used as
    applyInfoBackground: { type: Boolean, default: false }, // indicate if apply 'bg-info-row' class to all rows of the table (see applyInfoBackground())
    hasSubtable: { type: Boolean, default: false }, // indicates if subtable exists
    subtableComponent: Object, // component to be rendered if subtable
    selectedableRows: {
      type: Boolean,
      default: false,
    },
    selectedRow: {
      type: null,
      default: null,
    },
    nameOfEnableDisabledEvents: { type: Array, default: () => [] },
    hasTotalsRow: {
      type: Boolean,
      default: false,
    },
    totalsRowData: {
      type: Object,
        default: () => {},
    },
    shouldBeReadonlyForOtherReasons: {
      type: Function,
      default: () => false,
    },
    shouldDisableActions: {
      type: Boolean,
      default: false,
    },
    showUnorderedIcon: {
      type: Boolean,
      default: false,
    },
    allowDeletedRows: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      lstColumns: [],
      lstColsAndSort: [],
      selectedRows: [],
      showColConfigDiv: false,
      idcolumnListModal: crypto.randomUUID(),
      keyDate: null,
      showTotals: false,
    };
  },

  computed: {
    tableId() {
      return this.lstColumns[0].BusinessId || this.uniqueTableName;
    },

    lstOfDatRows() {
      let rows = this.dataRows;

      if (!this.allowDeletedRows) {
        rows = rows.filter(({ IsDeleted }) => !IsDeleted);
      }

      rows.map((row) => {
        row.RowId = row.RowId ?? crypto.randomUUID();
        return row;
      });

      if (this.hasSubtable) {
        // If subtable, make all groups collapsed
        rows.forEach((row) => (row.collapsed = true));
      }

      // Apply sorting if it exists
      if (this.lstColsAndSort.length) {
        // Necessary to apply the last one to enter the list
        const orderByLastElement = [...this.lstColsAndSort].reverse();
        rows = _.orderBy(
          rows,
          orderByLastElement.map(({ fld }) => fld),
          orderByLastElement.map(({ sort }) => sort.toLowerCase())
        );
      }

      return rows;
    },

    SelectedRow: {
      get() {
        return this.selectedRow;
      },
      set(newVal) {
        this.$emit('update:selected-row', newVal);
      },
    },

    columnsToDisplay() {
      return this.lstColumns.filter(({ FieldControlType }) => FieldControlType !== 'headerbutton' && FieldControlType !== 'section') || [];
    },

    dataColumnsForNewRow() {
      return this.columns?.filter(({ FieldControlType, CellType }) => FieldControlType !== 'headerbutton' && FieldControlType !== 'section' && CellType !== 'LinkType');
    },

    modalColumns: {
      get() {
        return this.lstColumns?.filter(({ FieldControlType }) => FieldControlType !== 'button' && FieldControlType !== 'headerbutton' && FieldControlType !== 'section');
      },
      set(newVal) {
        const buttonIndex = this.lstColumns.findIndex(({ FieldControlType }) => FieldControlType === 'button');
        const buttons = this.lstColumns.filter(({ FieldControlType }) => FieldControlType === 'button');

        const areButtonAtEnd = buttonIndex >= newVal.length;
        if (areButtonAtEnd) {
          this.lstColumns = [...newVal, ...buttons];
        } else {
          this.lstColumns = [...buttons, ...newVal];
        }
      },
    },

    headerButtons() {
      return this.columns?.filter(({ FieldControlType }) => FieldControlType === 'headerbutton');
    },

    sectionLabel() {
      return this.columns?.find(({ FieldControlType }) => FieldControlType === 'section')?.Label;
    },

    isAllRowSelected() {
      return this.dataRows?.length === this.selectedRows?.length && this.selectedRows?.length > 0;
    },

    isEmitingValues() {
      return !!this.valueTable;
    },
    allTheColumnsAreConfidential() {
      return this.columnsToDisplay.filter(({ FieldControlType }) => ['select', 'checkbox', 'input', 'datepicker'].includes(FieldControlType)).every(({ IsConfidential }) => IsConfidential);
    },
    
  },

  watch: {
    /**
     * Watcher para reaccionar al cambio en la propiedad que contiene las columnas con lo
     * que se rellena el dato de lista de columnas internas para poder operar con ellas.
     * @param newVal
     */
    columns: {
      immediate: true,
      handler(newVal) {
        this.lstColumns = newVal?.map((col) => {
          const newCol = _.clone(col);
          if (!_.has(newCol, 'VisibleByDefault')) {
            newCol.VisibleByDefault = false;
          }
          if (newCol.VisibleByDefault) {
            newCol.gtShown = newCol.gtShown !== null ? newCol.gtShown : true;
          } else {
            newCol.gtShown = false;
          }
          return newCol;
        });
        this.generateTableConfig();
      },
    },

    nSelectedRows(selectedRows) {
      this.selectedRows = selectedRows ?? [];
    },

    /**
     * Watcher para verificar que se ha seleccionado una fila desde fuera de la tabla - para interacción markers y tabla
     * @param row
     */
    outsideRowSelected(row) {
      if (row) {
        this.fnRowClick(row);
      } else {
        // Se limpia la selección de filas
        this.selectedRows = [];
      }
    },

    data: {
      immediate: true,
      deep: true,
      handler() {
        this.computeCellValue();
      },
    },

    dataRows: {
      immediate: true,
      deep: true,
      handler() {
        this.computeCellValue();
      },
    },
  },

  methods: {
    ...mapActions('toastModule', {
      toastSuccess: 'success',
      toastError: 'error',
    }),

    handleTableInput(row) {
      this.$emit('update:row', { row, table: this.dataRows });
    },

    computeCellValue() {
      this.columns
        .filter(({ ComputedOperation }) => ComputedOperation)
        .forEach(({ InternalField, ComputedOperation }) => {
          for (const dataRow of this.dataRows) {
            let result = null;
            result = computedOperationUtils.getComputedValueFromTableAndModel(ComputedOperation, dataRow, this.data, 'Value');
            this.$set(dataRow, InternalField, result);
          }
        });
    },

    handleRowClick(row) {
      // Selecting text counts as a click, so we have to keep in mind if there is any text selected. In that case, the selection type would be 'range'. In that case, we don't want to treat it as a click.
      const { type } = window.getSelection();
      if (type === 'Range') return;

      this.setSelectedRow(row);
    },

    setSelectedRow(row) {
      if (JSON.stringify(this.SelectedRow) === JSON.stringify(row)) {
        this.SelectedRow = null;
      } else {
        this.SelectedRow = row;
      }
    },

    generateTableConfig() {
      this.keyDate = Date.now();

      const columnsSorted = _.sortBy(this.columns, ['Order']);

      // Search if some totals flag to show last row
      if (columnsSorted.some((col) => col.IstotalRow)) {
        this.showTotals = true;
      }

      try {
        if (this.uniqueTableName) {
          /* Se carga la configuración */
          const configColumns = jllLocalstorageManager.get(this.uniqueTableName);
          if (!!configColumns) {
            const configColumnsObject = configColumns;
            const configObjectSelected = configColumnsObject.find((col) => col.tblName === this.uniqueTableName);
            if (!!configObjectSelected) {
              this.setColumnsOrderFromLocalStorage(columnsSorted, configObjectSelected);
            } else {
              this.setColumnsAtEndByOrder(columnsSorted);
            }
          } else {
            this.setColumnsWithoutConfigInLocal(columnsSorted);
          }
        } else {
          /* Se inicializan las columnas y su gestión de visibilidad no se marca para guardar configuración */
          this.lstColumns = columnsSorted
            .filter(({ VisibleByDefault }) => VisibleByDefault)
            .map((col, index) => {
              const newCol = { ...col };
              newCol.gtOrder = index;

              if (!_.has(newCol, 'VisibleByDefault')) {
                newCol.VisibleByDefault = false;
              }

              newCol.gtShown = newCol.VisibleByDefault;

              return newCol;
            });
        }
      } catch (err) {
        Console.error(`TblGen - ${err.message}`);
      }
    },

    setColumnsOrderFromLocalStorage(columnsSorted, configObjectSelected) {
      /* Se inicializan las columnas y su gestión de visibilidad pero con la configuración*/
      let lastOrder = 10000;
      this.lstColumns = columnsSorted.map((col) => {
        const newCol = { ...col };
        if (!_.has(newCol, 'VisibleByDefault')) {
          newCol.VisibleByDefault = false;
        }

        /* Se busca el campo en configuración */
        const colCfg = configObjectSelected.colCfg.find((x) => x.fld === col.InternalField && x.lbl === col.Label) ?? {};

        /* Se asigna visibilidad en función de la configuración */
        if (Object.prototype.hasOwnProperty.call(colCfg, 'gtShown')) {
          newCol.gtShown = colCfg.gtShown;
        } else {
          newCol.gtShown = newCol.VisibleByDefault;
        }

        /* Si la configuración indica el orden se pone en otro caso se indica al final por orden */

        if (Object.prototype.hasOwnProperty.call(colCfg, 'gtOrder')) {
          newCol.gtOrder = colCfg.gtOrder;
        } else {
          newCol.gtOrder = lastOrder++;
        }

        return newCol;
      });
      this.lstColumns = _.sortBy(this.lstColumns, ['gtOrder']);
    },

    setColumnsAtEndByOrder(columnsSorted) {
      let lOrder = 0;
      this.lstColumns = columnsSorted.map((col) => {
        const newCol = { ...col };
        if (!_.has(newCol, 'VisibleByDefault')) {
          newCol.VisibleByDefault = false;
        }

        if (newCol.VisibleByDefault === true && !_.has(newCol, 'gtShown')) {
          newCol.gtShown = true;
        } else if (newCol.VisibleByDefault !== true) {
          newCol.gtShown = false;
        }

        newCol.gtOrder = lOrder++;
        return newCol;
      });
    },

    setColumnsWithoutConfigInLocal(columnsSorted) {
      /* Se inicializan las columnas y su gestión de visibilidad No hay configuración prévia*/
      this.lstColumns = columnsSorted.map((col, index) => {
        const newCol = { ...col };
        newCol.gtOrder = index;

        if (!_.has(newCol, 'VisibleByDefault')) {
          newCol.visible = false;
        }

        newCol.gtShown = newCol.VisibleByDefault;

        return newCol;
      });
      jllLocalstorageManager.set(this.uniqueTableName, this.lstColumns);
    },

    /**
     * Cambia toda selección.
     * */
    fnToggleAllSel() {
      this.selectedRows = this.isAllRowSelected ? [] : [...this.lstOfDatRows];

      this.fnEmitAllRowSelected();
    },

    /**
     * Gestión del click en una fila
     * @param row
     */
    fnRowClick(row, index, isDouble) {
      if (!this.selectedRows.length) {
        this.selectedRows.push(row);
      } else {
        if (this.multiselect) {
          /* Se itera entre los seleccionados si se encuentra se elimina */
          let found = false;
          for (let lCnt = 0; lCnt < this.selectedRows.length; lCnt++) {
            if (
              _.isEqual(this.selectedRows[lCnt], row) ||
              (this.keyField !== null && this.keyField !== 'undefined' && _.has(this.selectedRows[lCnt], this.keyField) && _.has(row, this.keyField) && this.selectedRows[lCnt][this.keyField] === row[this.keyField])
            ) {
              found = true;
              this.selectedRows.splice(lCnt, 1);
            }
          }
          if (!found) this.selectedRows.push(row);
        } else if (this.selectedRows.length === 1) {
          this.selectedRows.splice(0, 1);
          if (
            !_.isEqual(this.selectedRows[0], row) &&
            !(this.keyField !== null && this.keyField !== 'undefined' && _.has(this.selectedRows[0], this.keyField) && _.has(row, this.keyField) && this.selectedRows[0][this.keyField] === row[this.keyField])
          ) {
            this.selectedRows.push(row);
          }
        }
      }

      this.fnEmitRowSelected(index, isDouble);
    },

    /**
     * Gestión del doble click en una fila
     * @param row
     */
    fnDoubleRowClick(row, index) {
      // Misma funcionalidad que un único click - indicar que es double para lanzar evento distinto
      this.fnRowClick(row, index, true);
    },

    fnEmitRowSelected(index, isDouble) {
      /* Indicar evento que se genera -> cambio de selección (click simple) o doble click */
      const clickEvt = isDouble ? 'evt-generic-table-double-click' : 'evt-generic-table-change-selection';

      /* Se clona la lista seleccionada */
      const cpyRows = _.cloneDeep(this.selectedRows);
      if (this.selectedRows.length > 0) {
        this.$emit(
          clickEvt,
          this.multiselect
            ? {
                rows: cpyRows,
                index,
              }
            : cpyRows[0]
        );
      } else {
        this.$emit(clickEvt, this.multiselect ? { rows: null, index } : null);
      }
    },

    fnEmitAllRowSelected() {
      this.$emit('evt-generic-table-all-selection', {
        rows: this.selectedRows.length ? _.cloneDeep(this.selectedRows) : null,
      });
    },

    /**
     * Indica si una fila está seleccionada
     * @param row
     */
    isRowSelected(row) {
      /* SI no hay seleccionados se añade y punto */
      return (
        (this.SelectedRow && JSON.stringify(this.SelectedRow) === JSON.stringify(row)) ||
        this.selectedRows?.some((selectRow, index) => {
          if (_.isEqual(selectRow, row)) {
            return true;
          } else if (this.keyField !== null && this.keyField !== 'undefined' && _.has(selectRow, this.keyField) && _.has(row, this.keyField) && selectRow[this.keyField] === row[this.keyField]) {
            this.selectedRows[index] = row; // overwrite selectedRow with updated value
            return true;
          }
          return false;
        })
      );
    },

    /**
     * Gestión de la ordenación por click en una de las columnas.
     * @param col
     */
    fnSortBy(col) {
      if (!col.CanSort) return;

      /* Se fija el sentido de ordenación */
      if (col.sort === 'NOS') {
        col.sort = 'ASC';
      } else if (col.sort === 'ASC') {
        col.sort = 'DESC';
      } else {
        col.sort = 'NOS';
      }

      if (this.outsideSort) {
        this.lstColumns.forEach((x) => {
          if (x.InternalField !== col.InternalField) x.sort = 'NOS';
        });
        return this.$emit('sortBy', col);
      }

      /* Se busca en la colección */
      const idx = this.lstColsAndSort.findIndex((x) => x.fld === col.InternalField);

      /* Se recompone el array de columnas y su orden para dejarlo sincronizado para el evento */
      if (col.sort === 'NOS') {
        /* Hay que quitarla de la colección */
        if (idx > -1) this.lstColsAndSort.splice(idx, 1);
      } else {
        /* Si existe se cambia el orden a ASC o DESC*/
        if (idx > -1) {
          this.lstColsAndSort[idx].sort = col.sort;
        } else {
          /* No se ha encontrado se añade al final */
          this.lstColsAndSort.push({
            fld: col.InternalField,
            sort: col.sort,
          });
        }
      }
    },

    /**
     * Devuelve el orden en la ordenación de columnas de la col
     * @param pCol
     */
    badgeColSortOrder({ fld }) {
      /* Hay que quitarla de la colección */
      const idx = this.lstColsAndSort.findIndex((x) => x.fld === fld);
      return idx > -1 ? idx + 1 : idx;
    },

    fnGetUrl(col, entry) {
      let url = '';
      if (_.has(col, 'url') && _.isFunction(col.url)) {
        /* Se llama al callback de verificación que conoce el padre */
        url = col.url(col.fld, entry);
      }

      return url;
    },

    /**
     * Función para llamar a un callback cuando se hace click en un botón de una columna.
     * @param {object} col valores de la columna donde se ha hecho click
     * @param {object} entry valores de la fila donde se ha hecho click
     */
    fnCallBack(event, col, entry) {
      // this is in case of we need to do some event and is blocked by readonly prop.
      if (this.readonly) {
        if (this.nameOfEnableDisabledEvents.includes(col?.EmitEventName)) {
          this.$emit(col.EmitEventName, { event, column: col, valueRow: entry });
        }
      }

      /* Se verifica que la columna tenga propiedad de actuación */
      if ((!this.readonly && col.hasOwnProperty('EmitEventName')) || col.EmitEventName === 'showAuditLog') {
        /* Se llama a las funciones de añadir o eliminar fila */
        if (col.EmitEventName === 'addRow') {
          this.addRow();
        } else if (col.EmitEventName === 'deleteRow') {
          this.deleteRow(entry);
        } else {
          /* Se llama al callback de actuación para que implemente en su instancia EJ: @fnDelete="doSomething" */
          this.$emit(col.EmitEventName, { event, column: col, valueRow: entry });
        }
      }
    },

    /**
     * Función que determina si una casilla es visible o no.
     */
    evalRowConditions(row) {
      if (row && row.Conditions) {
        return pixEvaluateUtils.evalConditions(row.Conditions, row, null, null);
      } else {
        return true;
      }
    },

    /**
     * Función que determina si una columna es visible o no. (definida en la columna del padre)
     * @param col
     */
    fnEvalCondition(sConditions, value, index) {
      if (sConditions) {
        let metCondition = false;
        if (_.isFunction(this.$parent[sConditions])) {
          // If conditions is a function
          metCondition = this.$parent[sConditions]();
        } else {
          // When evaluating field condition
          if (index !== undefined && index !== null) {
            const element = this.lstOfDatRows[index];
            const internalFields = pixRegexUtils.getRegexMatches(regexConst.WHOLE_WORD_GENERIC_FORM, sConditions);
            for (const internalField of internalFields) {
              let modelValue = element[internalField];
              if (_.isFunction(this.$parent[internalField])) {
                sConditions = sConditions.replace(internalField, this.$parent[internalField](value));
              } else {
                if (typeof modelValue === 'string') modelValue = `'${modelValue}'`;
                sConditions = sConditions.replace(internalField, modelValue);
              }
            }
            metCondition = eval(sConditions);

            // When evaluating column condition
          } else {
            // If conditions is combined fields
            const internalFields = pixRegexUtils.getRegexMatches(regexConst.WHOLE_WORD_GENERIC_FORM, sConditions);
            let index = 0;
            while (!metCondition && index < this.lstOfDatRows.length) {
              const element = this.lstOfDatRows[index];
              for (const internalField of internalFields) {
                if (_.isFunction(this.$parent[internalField])) {
                  sConditions = sConditions.replace(internalField, this.$parent[internalField](value));
                } else {
                  let value = element[internalField];

                  if (typeof value === 'string') value = `'${value}'`;

                  sConditions = sConditions.replace(internalField, value);
                }
              }
              metCondition = eval(sConditions);
              index++;
            }
          }
        }

        return metCondition;
      } else return true;
    },

    /**
     * Función que determina si una columna es visible o no en función de los roles
     * @param col
     */
    fnIsVisible(col) {
      const bAuth = col.AuthorizedRoles ? this.$store.getters['authModule/isInRoleArr'](col.AuthorizedRoles) : true;
      const bNonAuth = col.NonAuthorizedRoles ? !this.$store.getters['authModule/isInRoleArr'](col.NonAuthorizedRoles) : true;

      return bAuth && bNonAuth;
    },

    /**
     * Función para lanzar la callbanck indicada en la propiedad
     * fnFormat de la columna para que el padre formatee según considere.
     * @param col
     * @param entry
     */
    fnCustomFormatCallBack(col, entry) {
      /* Se verifica que la columna tenga propiedad de actuación */
      if (_.has(col, 'fnFormatCell') && _.isFunction(col.fnFormatCell)) {
        /* Se llama al callback de formateo que conoce el padre */
        return col.fnFormatCell(col.fld, entry);
      } else {
        return entry[col.fld];
      }
    },

    /**
     * Función formatear el value por codPram.
     * */
    formatValueCodParam(value, paramListValues) {
      try {
        let multiValues = [];

        if (typeof value === 'string' && value !== '') {
          multiValues = value.split(';');
          return this.checkMultiselectValues(multiValues, paramListValues);
        } else if (typeof value === 'number') {
          return this.checkMultiselectValues([String(value)], paramListValues);
        } else if (typeof value === 'boolean' && value !== '') {
          return value ? 'Yes' : 'No';
        }
        return value;
      } catch (e) {
        return 'Error FieldDataType Format';
      }
    },

    checkMultiselectValues(multiValues, list) {
      return multiValues?.map((singleValue) => list?.find(({ ValueCode }) => ValueCode === singleValue)?.ValueDesc)?.toString() ?? '';
    },

    fnGenerateFormat(col, entry) {
      if (!_.has(col, 'Format')) return null;

      if (!_.isFunction(col.Format))
        // Has sufix and it isn't a function. Return the field value.
        return entry[col.Format];
    },

    fnEnabledField(col, entry) {
      if (!_.has(col, 'enabled')) return true;

      if (!_.isFunction(col.enabled))
        // Has enabled and it isn't a function. Return the field value.
        return col.enabled;

      if (!_.has(col, 'enabledParams'))
        // It's a function without parameter.
        return col.enabled();

      // It's a function and has one or more parameters. If there are more than one parameter, this must be treated by the concrete table.
      return col.enabled(entry, col.enabledParams);
    },

    /**
     * Función para mostrar o no la modal de columnas
     */
    fnShowColModal() {
      if (this.allowColumnConfig) {
        if (this.showModalColumnConfig) {
          this.$refs.modalColumns.classList.add('show');
        } else {
          this.showColConfigDiv = true;
        }
      }
    },

    shouldShowUnorderedIcon(column) {
      return column.sort === "NOS" && column.CanSort === true && this.showUnorderedIcon;
    },

    /**
     * Función para cerrar la modal de columnas
     */
    closeModal() {
      this.$refs.modalColumns.classList.remove('show');
    },

    /**
     * Guarda la configuración de la tabla en localstorage
     * */
    fnSaveTableConf() {
      try {
        const tableName = this.uniqueTableName ? this.uniqueTableName : 'PixGenericTableConfig';
        const configStr = jllLocalstorageManager.get(tableName);

        /* Si existe se guarda la configuración */
        if (configStr) {
          const cfgObj = configStr;
          const pCfgTbl = cfgObj.find((x) => x.tblName === this.uniqueTableName);

          /* Si no hay en la colección de configuraciones una tabla de este nombre */
          if (!pCfgTbl) {
            const cfgItem = {
              tblName: this.uniqueTableName,
              colCfg: [],
            };
            let lOrder = 0;

            cfgItem.colCfg = this.modalColumns.map((columns) => {
              return {
                fld: columns.InternalField,
                lbl: columns.Label,
                gtShown: columns.gtShown,
                gtOrder: lOrder++,
              };
            });

            cfgObj.push(cfgItem);
            jllLocalstorageManager.set(tableName, cfgObj);
          } else {
            /* Si ya hay en la colección de configuraciones */
            pCfgTbl.colCfg = [];
            let lOrder = 0;

            pCfgTbl.colCfg = this.modalColumns.map((columns) => {
              return {
                fld: columns.InternalField,
                lbl: columns.Label,
                gtShown: columns.gtShown,
                gtOrder: lOrder++,
              };
            });

            jllLocalstorageManager.set(tableName, cfgObj);
          }
        } else {
          const cfgItem = { tblName: this.uniqueTableName, colCfg: [] };
          let lOrder = 0;

          cfgItem.colCfg = this.modalColumns.map((columns) => {
            return {
              fld: columns.InternalField,
              lbl: columns.Label,
              gtShown: columns.gtShown,
              gtOrder: lOrder++,
            };
          });

          const arrConf = [];
          arrConf.push(cfgItem);
          jllLocalstorageManager.set(tableName, arrConf);
        }
        this.toastSuccess(this.$t('components.genericTable.columnList.msgConfigSaved'));
      } catch (err) {
        this.toastError(this.$t('components.genericTable.columnList.msgConfigSavedErr'));
      }
    },

    /**
     * Resetea la configuración de mostrar columnas de la tabla.
     * */
    fnResetTableConf() {
      const columnsSorted = _.sortBy(this.lstColumns, ['Order']);
      columnsSorted.forEach((col, index) => {
        const confCol = columnsSorted.find((x) => x.InternalField === col.InternalField && x.Label === col.Label); // It's possible that several columns has empty fld, so let's use fld && lbl
        if (confCol !== null) {
          confCol.gtOrder = index;
          confCol.gtShown = _.has(col, 'VisibleByDefault') ? col.VisibleByDefault : false;
        }
      });
      this.lstColumns = _.sortBy(this.lstColumns, ['gtOrder']);
    },

    /**
     * Lanza evento indicando mouse over
     * @param entry
     * */
    fnMouseOver(index) {
      this.$emit('evt-generic-table-mouseover', index);
    },

    /**
     * Lanza evento indicando mouse leave
     * @param entry
     */
    fnMouseLeave(index) {
      this.$emit('evt-generic-table-mouseleave', index);
    },

    /**
     * Funciones para obtener params de formateo
     * @param index
     */
    getCurrencyParam(index) {
      return this.lstOfDatRows[index].currencyParamShortName || '';
    },
    getAreaParam(index) {
      return this.lstOfDatRows[index].areaParamShortName || '';
    },
    getFreqParam(index) {
      return this.lstOfDatRows[index].rentFrecuencyParamShortName || '';
    },
    getPrecedentNum(index) {
      return this.lstOfDatRows[index].precentNumber || '';
    },

    /**
     * Obtener el valor del campo al que se quiere acceder
     * @param entry
     * @param col
     */
    fnGetDataValue(entry, col) {
      // Get value from row based on internalField
      let value = entry[col.InternalField];

      if (value === undefined || value === null) {
        // Get value from row based on internalField (to lower)
        value = entry[pixUtils.toCamelCase(col.InternalField)] || null;
      }

      if (col.InitEventName) {
        try {
          // Execute function to get value
          // Get value from parent initEventName
          value = this.$parent[col.InitEventName](entry);
        } catch (err) {
          // NtD
        }
      }
      return value;
    },

    /**
     * Obtener el total de un campo - SUMA
     **/
    fnGetTotalValue(col) {
      let value = _.sumBy(this.lstOfDatRows, col.InternalField);
      if (value === undefined) {
        try {
          // Look into model
          value = this.$parent.fnCalculateFromProperties(col);
        } catch (err) {
          // NtD
        }
      }
      return value;
    },

    emitValues() {
      if (this.isEmitingValues) {
        this.$emit();
      }
    },

    addRow() {
      const newRow = this.dataColumnsForNewRow.reduce((pv, { InternalField }) => ({ ...pv, [InternalField]: null }), {});

      newRow.IsDeleted = false;
      newRow.isNew = true;
      newRow.RowId = crypto.randomUUID();

      // Do not mutate value prop.
      this.$emit('update:dataRows', [...this.dataRows, newRow]);
    },

    deleteRow(entry) {
      // Do not mutate value prop.
      let aux = [...this.dataRows];
      const el = aux.find((r) => _.isEqual(entry, r));
      el.IsDeleted = true;

      aux = aux.filter(({ isNew, IsDeleted }) => !(IsDeleted && isNew));

      // reorder elements so that deleted ones are always last
      aux.forEach((row, index) => (row.index = index));
      aux.sort((firstEl, secondEl) => {
        if (firstEl.IsDeleted) {
          return 1;
        } else if (secondEl.IsDeleted) {
          return -1;
        }
        return firstEl.index - secondEl.index;
      });
      aux.forEach((row) => {
        delete row.index;
      });

      this.$emit('update:dataRows', aux);
    },

    /**
     * It is used to obtain the related parameters in the select and multiselect components.
     */
    getParamList(col, entry) {
      const { ParamListValues, ParamListRel, RelationRowId } = col;
      const Value = entry[col.InternalField];
      let paramList = ParamListValues;

      if (ParamListRel) {
        const relationCol = this.lstColumns?.find((col) => col.RowId === RelationRowId);
        if (!relationCol) return;

        const relFieldValue = entry[relationCol.InternalField];

        const relValue = Array.isArray(relFieldValue) ? relFieldValue : [relFieldValue];
        const outValues = relValue.reduce((pv, cv) => {
          const ValuesOUTCode = ParamListRel.find((rel) => rel.ValueINCode === cv)?.ValuesOUTCode;
          return ValuesOUTCode ? [...pv, ...ValuesOUTCode] : pv;
        }, []);

        if (!relValue.length || !relValue[0] || !outValues?.length) {
          paramList = [];
        } else {
          paramList = ParamListValues.filter((v) => outValues.includes(v.ValueCode));
          if (Array.isArray(Value)) {
            const filtered = Value.filter((v) => outValues.includes(v));
            if (filtered.length !== Value.length) {
              entry[col.InternalField] = Value.filter((v) => outValues.includes(v));
            }
          } else if (Value && !outValues.includes(Value)) {
            entry[col.InternalField] = null;
          }
        }
      }

      return paramList;
    },

    shouldBeReadOnly(col) {
      const isReadonlyForOtherReasons = !!this.shouldBeReadonlyForOtherReasons(col);

      return isReadonlyForOtherReasons;
    },
  },
};
</script>

<style scoped>
.pix-generic-table {
  width: 100%;
}

.pix-generic-table thead {
  border: solid 1px #dee2e6;
}

.pix-generic-table th {
  background-color: #d8d8d8;
  white-space: nowrap;
  font-weight: 600;
  font-size: 14px;
  color: #000;
  height: 40px;
}

.pix-generic-table td {
  /* overflow-wrap: anywhere; */
  /* word-break: break-all; */
  white-space: nowrap;
  height: 43px;
  font-size: 16px;
  color: #35495e;
  border: solid 1px #dee2e6;
}

.pix-generic-table th,
.pix-generic-table td {
  padding: 0.3rem;
}

.pix-generic-table tr {
  background-color: #fff;
  transition: background-color 0.2s;
}

.pix-generic-table tr:hover {
  color: #000;
  background-color: #00000013;
}

.wPointer {
  cursor: pointer;
}

.grabbable {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.sm-field-width {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.md-field-width {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bold {
  font-weight: bold;
}

.bg-info-row {
  background-color: #eaf5fb;
}

.text-end {
  text-align: end;
}
.totals-font-style {
  font-weight: bold;
  font-size: 14px;
}

.subtableFontSize {
  font-size: 15px;
}
.subtableBackground {
  background: white;
}

.table-bordered th {
  height: 40px;
}

.table-bordered td {
  height: 43px;
  font-size: 16px;
  color: #35495e;
}

.table-responsive,
.pix-generic-table__content {
  white-space: nowrap;
}

.pix-generic-table__content >>> .datepicker td {
  white-space: normal;
}

.pix-generic-table__content {
  overflow: visible;
}

.table__actions {
  display: flex;
  gap: 10px;
  padding-bottom: 10px;
}

.pix-generic-form__container {
  border-radius: 3px;
  box-shadow: 2px 2px 4px 0 rgb(0 0 0 / 20%);
  border: solid 2px #898b8e;
  background-color: #ffffff;
  /* margin: 0 38px 18px 38px; */
  padding: 12px 16px;
  position: relative;
  margin-bottom: 20px;
}

.pix-generic-form__container__header__title {
  margin-bottom: 16px;
  font-size: 20px;
  color: #404040;
  font-weight: 600;
  flex: 1;
}

.pix-generic-table__total-row {
  border-top: solid 2px #404040;
}

.pix-generic-table__total-row .pix-generic-table__total-cell {
  border: none;
}

.center-spinner {
  text-align: center;
  margin-top: 50px;
}

.mdi-spinner {
  font-size: 120px;
  color: var(--jll-red-400);
}

.loading-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  opacity: 50%;
}

.mdi-blank {
  margin-left: 15px;
}

.show {
  display: block;
  opacity: 1;
  transition: transform 0.3s ease-out, opacity 0.3s;
  transform: translate(0, 50px);
}

.up-down-icon {
  position: relative;
  left: -14px;
}

.up-down-icon .mdi.mdi-menu-up {
  position: absolute;
  top: -3px;
}

.up-down-icon .mdi.mdi-menu-down {
  position: absolute;
  top: 2px;
}
</style>
